export default __webpack_public_path__ + "static/media/DownloadWhite.b69f8f46.svg";